import { Typography, Grid, Box } from "@mui/material";
import React from "react";
import { WelcomeAdminContext } from "../context/welcomeAdminContext";
import IDashboardDTO from "../interface/iDashboardDTO";

const NextDays = (): React.JSX.Element => {
  const {
    dashboardDTO,
  }: {
    dashboardDTO: IDashboardDTO;
  } = React.useContext(WelcomeAdminContext);

  return (
    <React.Fragment>
      <Typography
        variant="body1"
        component="h1"
        sx={{ mb: 2, fontWeight: "bold", textAlign: "center" }}
      >
        Übersicht über die nächsten 30 Tage
      </Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              borderRadius: 2,
              p: 2,
              textAlign: "center",
              backgroundColor: (theme) => theme.palette.grey[100],
            }}
          >
            <Typography
              variant="h3"
              component="div"
              sx={{ mb: 1, fontWeight: "bold" }}
            >
              {dashboardDTO.appointments.free.length}
            </Typography>
            <Typography sx={{ color: "text.secondary" }} variant="body2">
              Freie Termine
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={4}>
          <Box
            sx={{
              borderRadius: 2,
              p: 2,
              textAlign: "center",
              backgroundColor: (theme) => theme.palette.grey[100],
            }}
          >
            <Typography
              variant="h3"
              component="div"
              sx={{ mb: 1, fontWeight: "bold" }}
            >
              {dashboardDTO.appointments.booked.length}
            </Typography>
            <Typography sx={{ color: "text.secondary" }} variant="body2">
              Gebuchte Termine
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={4}>
          <Box
            sx={{
              borderRadius: 2,
              p: 2,
              textAlign: "center",
              backgroundColor: (theme) => theme.palette.grey[100],
            }}
          >
            <Typography
              variant="h3"
              component="div"
              sx={{ mb: 1, fontWeight: "bold" }}
            >
              {dashboardDTO.appointments.speedcoaching.length}
            </Typography>
            <Typography sx={{ color: "text.secondary" }} variant="body2">
              Speedcoachings
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default NextDays;
